function loadScript(src, callback) {
  const element = document.createElement('script');
  if (callback) element.onload = callback;
  element.src = src;
  element.defer = true;
  element.crossOrigin = 'anonymous';
  document.getElementsByTagName('head')[0].appendChild(element);
}

function modulesSupported() {
  const element = document.createElement('script');
  return 'noModule' in element;
}

function loadProgressiveImg(callback) {
  if (!modulesSupported()) {
    loadScript('https://unpkg.com/@webcomponents/webcomponentsjs@2.5.0/custom-elements-es5-adapter.js', () => {
      loadScript('https://media.fashionunited.com/media/progressive-img/18/progressive-img.js', callback);
    });
  } else {
    loadScript('https://media.fashionunited.com/media/progressive-img/18/progressive-img.module.js', callback);
  }
}

function loadWebComponentsPolyfill(callback) {
  if (!('content' in document.createElement('template')
  && 'customElements' in window
  && 'attachShadow' in document.createElement('div'))) {
    loadScript('https://unpkg.com/@webcomponents/webcomponentsjs@2.5.0/webcomponents-bundle.js', () => {
      loadProgressiveImg(callback);
    });
  } else {
    loadProgressiveImg(callback);
  }
}


function loadAllScripts(callback) {
  if (!window.IntersectionObserver) {
    loadScript(
      'https://unpkg.com/intersection-observer@0.7.0/intersection-observer.js',
      () => loadWebComponentsPolyfill(callback),
    );
  } else {
    loadWebComponentsPolyfill(callback);
  }
}

loadAllScripts();
